import apiService from './api-service'

const investorsService = {}

/**
 * Retrieve a investors by it's id
 * @param  array params (optional)
 * @return investors
 */
investorsService.list = function (params) {
  return apiService.get(`/investor`, { params }).then(res => res.data)
}

/**
 * Retrieve a investors with contracts by it's id
 * @param  array params (optional)
 * @return investors
 */
investorsService.withContracts = function (params) {
  return apiService.get(`/investor_contracts`, { params }).then(res => res.data)
}

/**
 * Retrieve a investors contracts by it's id
 * @param  array params (optional)
 * @return investors
 */
investorsService.contracts = function (id, params) {
  return apiService.get(`/investor_contracts/${id}`, { params }).then(res => res.data)
}

/**
 * Retrieve a investors with banks by it's id
 * @param  array params (optional)
 * @return investors
 */
investorsService.withBanks = function (params) {
  return apiService.get(`/investor_banks`, { params }).then(res => res.data)
}

/**
 * Retrieve a investors banks by it's id
 * @param  array params (optional)
 * @return investors
 */
investorsService.banks = function (id, params) {
  return apiService.get(`/investor_banks/${id}`, { params }).then(res => res.data)
}

/**
 * Retrieve a investors by it's id
 * @param  int id
 * @param  array params (optional)
 * @return investors
 */
investorsService.getById = function (id, params) {
  return apiService.get(`/investor/${id}`, { params }).then(res => res.data)
}

/**
 * Update a investors by it's id
 * @param  int id
 * @param  array body
 * @return investors
 */
investorsService.updateById = function (id, body) {
  return apiService.put(`/investor/${id}`, body).then(res => res.data)
}

/**
 * Deletes an investor
 * @param int investor_id
 * @param  object body
 * @return response
 */
investorsService.deleteById = function (id, params) {
  return apiService.delete(`/investor/${id}`, { params }).then(res => res.data)
}

/**
 * Create a investors by it's id
 * @param  object body
 * @return investors
 */
investorsService.post = function (body) {
  return apiService.post(`/investor`, body).then(res => res.data)
}

/**
 * Create a bank data for investor's id
 * @param int investor_id
 * @param  object body
 * @return investors
 */
investorsService.postBankData = function (investorId, body) {
  return apiService.post(`/investor/${investorId}/bank_data`, body).then(res => res.data)
}

/**
 * Deletes a bank data for investor's
 * @param int investor_id
 * @param int bank_data_id
 * @param  object body
 * @return investors
 */
investorsService.deleteBankData = function (bankDataId) {
  return apiService.delete(`/investor/bank_data/${bankDataId}`).then(res => res.data)
}

/**
 * Create a contact for investor's id
 * @param int investor_id
 * @param  object body
 * @return investors
 */
investorsService.postContact = function (investorId, body) {
  return apiService.post(`/investor/${investorId}/contact`, body).then(res => res.data)
}

/**
 * Deletes a contact for investor's
 * @param int investor_id
 * @param int contact_id
 * @param  object body
 * @return investors
 */
investorsService.deleteContact = function (investorId, contactId) {
  return apiService.delete(`/investor/${investorId}/contact/${contactId}`).then(res => res.data)
}

/**
 * Deletes a file for investor's
 * @param int investor_id
 * @param int file_id
 * @param  object body
 * @return investors
 */
investorsService.deleteDocument = function (investorId, documentId) {
  return apiService.delete(`/investor/${investorId}/files/${documentId}`).then(res => res.data)
}

/**
 * Get a investors contact by it's id
 * @param  int investor_id
 * @param  int contact_id
 * @return Investor contact
 */
investorsService.getContact = function (investorId, contactId) {
  return apiService.get(`/investor/${investorId}/contact/${contactId}`).then(res => res.data)
}

/**
 * Edit a investors contact by it's id
 * @param  int investor_id
 * @param  int contact_id
 * @param  object body
 * @return investor contact
 */
investorsService.putContact = function (investorId, contactId, body) {
  return apiService.put(`/investor/${investorId}/contact/${contactId}`, body).then(res => res.data)
}

export default investorsService



// WEBPACK FOOTER //
// ./src/services/investors.js